import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.a
    href="https://wa.me/919820045678"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat with Agaman Freight on WhatsApp"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-amber-500 text-[#0D1117] shadow-[0_0_30px_rgba(245,158,11,0.35)] hover:bg-amber-400 transition-colors duration-200"
  >
    <MessageCircle className="w-6 h-6" />
  </motion.a>
);
